/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
// utils
// material
import { Button, displayModal, log } from '@insticator/insticator-ui';
import { ReactComponent as CheckCircle } from 'assets/icons/check-circle-outline.svg'
// content
import MigrationModal from '../migrationmodal/migrationmodal';
// styles
import injectSheet from "react-jss";
import styles from './migrationcomplete_styles';
import { updateMigrationStatus } from 'state/thunks/migration';
import { DATA_MIGRATION_CONFIRMED } from 'utils/consts/migration';

/* ========== ~~~~~~~~~~ MIGRATION STATUS WIDGET : COMPLETE ~~~~~~~~~~ ========== */
const MigrationComplete  = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { siteUUID } = useSelector(state => state.session);
  const { migrationStatus, isMigrationUpdating }= useSelector(state => state.migrationStatus)
  const adminEmail = useSelector(state => state.session.userEmail);

  const confirmMigration = useCallback(async () => {
    const response = await dispatch(updateMigrationStatus({
      siteId: siteUUID,
      data: {
        currentStatus: migrationStatus,
        adminEmail
      }
    }))
    log('response', response)
    if(response.payload) dispatch(displayModal(true, <MigrationModal migrationStatus={DATA_MIGRATION_CONFIRMED} />))
  },[dispatch])

  return (
    <div className={`migrationcomplete ${props.classes.migrationcomplete}`}>
      <div className='info'>
        <span className='icon'><CheckCircle height={30} width={30} /></span>
        <p className='text'>Commenting 2.0 Migration Complete!</p>
      </div>
      <Button text={'Confirm'} processing={isMigrationUpdating} processingText={'Confirming..'} handleClick={confirmMigration} />
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MigrationComplete